import { FileResponse } from "../../api/formApi";
import type { UserUuid } from "../../types/identity";

/**
 * `POST {file-service}/files` answers `{ files: [ <File model>, … ] }` — an OBJECT keyed
 * `files`, each entry carrying `id` / `file_name` / `file_type` / `file_size` /
 * `storage_path` (`file/app/Http/Controllers/FileController.php:74`).
 *
 * Every form read surface expects the `FileResponse` shape instead — `FormFieldRenderer`'s
 * read-only `file` branch does `Array.isArray(value)` then `value.map(f => f.name)`, so a
 * value that is not an array degrades to a bare "File uploaded" with no filename and no
 * downloadable id. This maps the wire shape onto `FileResponse` so an attachment lists by
 * name and keeps a real file id.
 *
 * Two ways of getting this wrong shipped before ClickUp 86d3y4e9e, one per path:
 *   - casting the whole `{ files: [...] }` object to `FileResponse[]` (stores a non-array)
 *   - reading `response.file_id`, which this endpoint never returns (stores `undefined`)
 *
 * ⚠️ `loaction` is misspelt in the `FileResponse` interface and in every stored
 * `form_responses` row. It is the persisted key — correcting the spelling here would
 * orphan the read side and all existing records.
 */
export const toFileResponses = (raw: any, patientId: UserUuid): FileResponse[] =>
	(Array.isArray(raw?.files) ? raw.files : []).map((f: any) => ({
		id: f.id,
		name: f.file_name,
		type: f.file_type,
		size: f.file_size,
		loaction: f.storage_path ?? `${patientId}/files/${f.id}`,
	}));
